import { useRoomOffers } from '@/features/room-selection'
import { useCartStore } from '@/stores/cart-store/cartStore'

export const useHotelMessages = () => {
	const { adults, children } = useCartStore.use.roomConfigurations()[0]

	const { data } = useRoomOffers({
		adults,
		childrenAges: children,
		selectedRoomCodes: [],
	})

	return data?.messages
}
